import { UserRoleE } from "../../models/enums";

export type ContactInfoGateInput = {
  clientId?: number | null;
  userId?: string;
  contactInfoConfirmed?: boolean;
  role?: string;
};

// Roles that never see the mandatory "Personal contact info" popup.
export const CONTACT_INFO_GATE_EXCLUDED_ROLES: string[] = [
  UserRoleE.GlobalAdmin,
  UserRoleE.GlobalAdminAndAdminContentManager,
  UserRoleE.DeliveryService,
];

// Pure, unit-tested rule for whether the mandatory contact-info popup should appear.
// Kept in its own module (no heavy imports) so it is testable without loading the popup UI chain.
export const shouldShowContactInfoGate = (i: ContactInfoGateInput): boolean =>
  !!i.userId &&
  i.clientId != null &&
  !i.contactInfoConfirmed &&
  !CONTACT_INFO_GATE_EXCLUDED_ROLES.includes(i.role ?? "");
